import React from 'react';
import classNames from 'classnames';
import styles from './index.module.less';
import Hero from './cpns/Hero';
import WhyErasa from './cpns/WhyErasa';
import HowToRecommend from './cpns/HowToRecommend';
import HowItWorks from './cpns/HowItWorks';
import Faq from './cpns/Faq';

export interface AffiliateProgramProps {
  /**
   * 在 Dashboard 弹窗内渲染时传 true。
   * 弹窗宿主页面已有自己的 h1，此时主标题降级为 h2，避免同页出现两个 h1。
   */
  isModal?: boolean;
}

const Index: React.FC<AffiliateProgramProps> = ({ isModal = false }) => {
  return (
    <div className={classNames(styles.container, { [styles.inModal]: isModal })}>
      {/* 背景晕染：设计稿 #10899:3642，纯装饰，不参与交互与无障碍树。
          弹窗面板 #10899:4656 是纯白底、没有这层，故 .inModal 里隐藏。 */}
      <div className={styles.backdrop} aria-hidden="true">
        <div className={styles.blobBlue} />
        <div className={styles.blobPink} />
      </div>
      <div className={styles.content}>
        <Hero isModal={isModal} />
        <WhyErasa isModal={isModal} />
        <HowToRecommend isModal={isModal} />
        <HowItWorks isModal={isModal} />
        <Faq isModal={isModal} />
      </div>
    </div>
  );
};

export default Index;
